import { render, staticRenderFns } from "./DetailsPage.vue?vue&type=template&id=45de7500&scoped=true"
import script from "./DetailsPage.vue?vue&type=script&lang=js"
export * from "./DetailsPage.vue?vue&type=script&lang=js"
import style0 from "./DetailsPage.vue?vue&type=style&index=0&id=45de7500&prod&scoped=true&lang=scss"
import style1 from "./DetailsPage.vue?vue&type=style&index=1&id=45de7500&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45de7500",
  null
  
)

export default component.exports